import React from 'react'

import {
  Wrapper,
  Title,
  Description,
  CallToActionWrapper,
  IconWrapper,
  PageFiller,
} from './EmptyState.styles'

// Icon
import { ReactComponent as DocumentIcon } from 'icons/document-64.svg'
import { ReactComponent as LinkLibraryIcon } from 'icons/link-library-64.svg'
import { ReactComponent as PersonCircle } from 'icons/person-circle-64.svg'
import { ReactComponent as SearchIcon } from 'icons/search-64.svg'
import { ReactComponent as NotesIcon } from 'icons/notes.64.svg'
import { ReactComponent as TrashBinIcon } from 'icons/trash-bin-64.svg'
import { ReactComponent as WorkspaceIcon } from 'icons/workspace-64.svg'
import { ReactComponent as SymbolIcon } from 'icons/symbol-64.svg'
import { ReactComponent as LayerStyleIcon } from 'icons/paint-brush-64.svg'
import { ReactComponent as TextStyleIcon } from 'icons/text-format-64.svg'
import { ReactComponent as ColorVariableIcon } from 'icons/color-swatch-64.svg'

const ICON_BY_NAME = {
  document: DocumentIcon,
  link: LinkLibraryIcon,
  search: SearchIcon,
  notes: NotesIcon,
  'person-circle': PersonCircle,
  'trash-bin': TrashBinIcon,
  workspace: WorkspaceIcon,
  symbol: SymbolIcon,
  layerStyle: LayerStyleIcon,
  textStyle: TextStyleIcon,
  colorVariable: ColorVariableIcon,
}

interface EmptyStateLayoutProps {
  title: React.ReactNode
  description: React.ReactNode
  callToAction?: React.ReactNode
  icon?: keyof typeof ICON_BY_NAME
}

const EmptyStateLayout: React.FC<EmptyStateLayoutProps> = props => {
  const { title, description, callToAction, icon } = props

  const Icon = ICON_BY_NAME[icon || 'document']

  return (
    <PageFiller>
      <Wrapper>
        <IconWrapper>
          <Icon />
          <span className="sr-only">{icon} icon</span>
        </IconWrapper>
        <Title>{title}</Title>
        <Description>{description}</Description>
        <CallToActionWrapper>{callToAction}</CallToActionWrapper>
      </Wrapper>
    </PageFiller>
  )
}

interface EmptyStateProps extends EmptyStateLayoutProps {
  search?: string
}

const EmptyState: React.FC<EmptyStateProps> = ({ search, ...props }) => {
  if (search) {
    return (
      <EmptyStateLayout
        icon="search"
        title="No search results"
        description="No document or Editor names matched your search."
      />
    )
  }

  return <EmptyStateLayout {...props} />
}

export default EmptyState
